import apiConfig from '@constants/apiConfig';
import UserAdminListPage from '.';

// Nguồn ra-log-monitor-cms: /admins là trang danh sách, tạo/sửa bằng modal
// -> KHÔNG có trang lưu riêng như template mreport.
export default {
    adminListPage: {
        path: '/admins',
        auth: true,
        component: UserAdminListPage,
        permission: [apiConfig.user.getList.permissionCode],
        pageOptions: {
            objectName: 'quản trị viên',
        },
    },
};
